module.exports = __webpack_public_path__ + "img/13.40c2adf8.jpg";